import { render, staticRenderFns } from "./DsUnitModule.vue?vue&type=template&id=45bce538&scoped=true&"
import script from "./DsUnitModule.vue?vue&type=script&lang=js&"
export * from "./DsUnitModule.vue?vue&type=script&lang=js&"
import style0 from "./DsUnitModule.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DsUnitModule.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./DsUnitModule.vue?vue&type=style&index=2&id=45bce538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bce538",
  null
  
)

component.options.__file = "DsUnitModule.vue"
export default component.exports